import React from 'react';

/**
 * Error boundary that reports to Rollbar but does NOT swallow the error.
 *
 * Unlike @rollbar/react's ErrorBoundary this component never sets hasError
 * state and always renders children — so Next.js' own error overlay / error
 * page still works as expected.
 */
class RollbarErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    if (typeof window !== 'undefined' && window.Rollbar) {
      window.Rollbar.error(error, { react: errorInfo });
    }
  }

  render() {
    return this.props.children;
  }
}

export default RollbarErrorBoundary;
